import { Shadows } from '@mui/material/styles/shadows';

export const shadows = [
  'none',
  '0px 16px 40px rgba(35, 41, 75, 0.24)',
  '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 1px 3px rgba(0, 0, 0, 0.12)',
  '2px 4px 16px rgba(35, 41, 75, 0.15), 4px 8px 48px rgba(35, 41, 75, 0.05)',
  '0px 4px 16px rgba(35, 41, 75, 0.15)',
].concat(Array.from({ length: 23 }, () => '')) as Shadows;
